export enum Color {
  BLUE = '#082EB5',
  BLUE_HOVER = '#06248C',
  BLUE_ACTIVE = '#00155E',
  PINK = '#FF04D5',
  PINK_HOVER = '#DA05B6',
  PINK_ACTIVE = '#BA029B',
  LIGHT_BLUE = '#0B75FD',
  LIGHT_BLUE_HOVER = '#007AFF',
  DARK_BLUE = '#091E6C',
  LIGHT_BLUE3 = '#0B75FD08',
  LIGHT_BLUE30 = '#0B75FD4D',
  TRANSPARENT = 'transparent',
  TABLE_GRADIENT = 'linear-gradient(279.09deg, #007AFF 0%, #2767F8 15.7%, #8938E5 51.03%, #FF00CF 90.95%)',

  ORANGE = '#FFA51F',
  ORANGE_HOVER = '#E3931A',
  ORANGE_ACTIVE = '#C87D0D',
  TURQUOISE = '#00B2D9',
  TURQUOISE_HOVER = '#019EC0',
  TURQUOISE_ACTIVE = '#0389A7',
  BRICK = '#611C06',
  BRICK_HOVER = '#8C330C',
  CORAL = '#C6420A',
  CORAL_HOVER = '#B23C09',
  CORAL_ACTIVE = '#A13608',
  CORAL3 = '#C6420A08',
  CORAL30 = '#C6420A4D',
  TABLE_GRADIENT2 = 'linear-gradient(97.17deg, #F45A29 3.99%, #CFB185 35.2%, #A3D09B 49.13%, #7CCEB5 63.06%, #00A9CE 96.2%)',
  BORDO = '#4D0000',

  WHITE = '#FFFFFF',
  BLACK = '#323232',
}
